export default __webpack_public_path__ + "static/media/info.7917e518.svg";